var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"messages",class:{
  'standby' : _vm.code === 0,
  'loading' : _vm.code === 1,
  'success' : _vm.code === 2,
  'errors' : _vm.code === 3,
}},[_c('span',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }